import { render, staticRenderFns } from "./DongleEvents.vue?vue&type=template&id=ca32e44a&scoped=true&"
import script from "./DongleEvents.vue?vue&type=script&lang=ts&"
export * from "./DongleEvents.vue?vue&type=script&lang=ts&"
import style0 from "./DongleEvents.vue?vue&type=style&index=0&id=ca32e44a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca32e44a",
  null
  
)

export default component.exports